export default {
  paginated (state) {
    return state.paginated
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js